export const normalizeQuotationLineText = (value = "") =>
  String(value || "")
    .replace(/<[^>]*>/g, " ")
    .replace(/&nbsp;/gi, " ")
    .replace(/\s+/g, " ")
    .trim()
    .toLowerCase();

const getFieldValues = (item = {}, fields = []) =>
  fields
    .map((field) => item?.[field])
    .filter((value) => value !== undefined && value !== null && value !== "")
    .map((value) => String(value));

export const findQuotationLineItem = (
  items = [],
  rfqLine = {},
  rowIndex = 0,
  {
    rfqIdFields = ["_id", "id"],
    quoteIdFields = ["id", "_id"],
    rfqTextFields = ["name"],
    quoteTextFields = ["name"],
  } = {},
) => {
  const list = Array.isArray(items) ? items : [];
  const rfqIds = getFieldValues(rfqLine, rfqIdFields);

  if (rfqIds.length) {
    const matchById = list.find((item) =>
      getFieldValues(item, quoteIdFields).some((id) => rfqIds.includes(id)),
    );
    if (matchById) return matchById;
  }

  const rfqTextKey = normalizeQuotationLineText(
    rfqTextFields.map((field) => rfqLine?.[field]).filter(Boolean).join(" "),
  );

  if (rfqTextKey) {
    const matchByText = list.find((item) => {
      const quoteTextKey = normalizeQuotationLineText(
        quoteTextFields.map((field) => item?.[field]).filter(Boolean).join(" "),
      );
      return quoteTextKey && quoteTextKey === rfqTextKey;
    });
    if (matchByText) return matchByText;
  }

  return list[rowIndex] || null;
};

export const getUnquotedItemsWarning = (rfqData, suppliers = []) => {
  const latestQuotes = suppliers
    .filter((supplier) => supplier?.quotationReceived && supplier?.isDeleted !== true && supplier?.exclusionDetails?.isExcludedFromComparison !== true)
    .map((supplier) => supplier.vendorQuotations?.quotationSets?.slice(-1)[0])
    .filter(Boolean);
  const unquotedItems = [];
  const checkItem = (name, getRate) => {
    const hasRate = latestQuotes.some((quote) => {
      const rate = Number(getRate(quote));
      return Number.isFinite(rate) && rate > 0;
    });
    if (!hasRate) {
      unquotedItems.push(String(name || "Item").replace(/<[^>]*>/g, " ").replace(/&nbsp;/gi, " ").trim());
    }
  };

  if (rfqData?.rfqType === "material" || rfqData?.rfqType === "labour") {
    const isMaterial = rfqData.rfqType === "material";
    const items = (isMaterial ? rfqData.materials : rfqData.labourDetails) || [];
    items.forEach((item, index) => checkItem(isMaterial ? item.name : item.skill, (quote) => {
      const line = findQuotationLineItem(isMaterial ? quote.materialDetails : quote.labourItems, item, index,
        isMaterial ? {} : { rfqTextFields: ["skill", "name"], quoteTextFields: ["skill", "name"] });
      if (line?.isAvailable === false) return 0;
      return isMaterial
        ? Number(line?.basePrice || 0) * (1 - Number(line?.discount || 0) / 100)
        : line?.labourRate;
    }));
  } else if (rfqData?.rfqType === "contractor") {
    (rfqData.providingFixingDetails || []).forEach((section) => {
      (section.scopes || []).forEach((scope) => {
        const findScope = (quote) => quote.contractorDetails
          ?.find((item) => String(item.id) === String(section._id))
          ?.scopes?.find((item) => String(item.id) === String(scope._id));
        if (scope.materials?.length) {
          scope.materials.forEach((material, index) => checkItem(material.name, (quote) =>
            findQuotationLineItem(findScope(quote)?.materials, material, index)?.totalExclGst));
        } else {
          checkItem(scope.scopeOfWork, (quote) => findScope(quote)?.totalExclGst);
        }
      });
    });
  }

  return unquotedItems.length
    ? `Cannot send for approval. No vendor has quoted a rate greater than 0 for: ${unquotedItems.join(", ")}.`
    : "";
};
